<template>
    <div>
         <ThatsTable title="Loyalty Members" ref="table" :multipleSelection="false" :endpoint="endpoint" :columns="columns" :newBtn="true" @open="openNewModal" @row-click="rowClick" :key="tableKey" :filterFormData="filterForm" @clearFilterForm="clearFilterForm" @viewRelatedDocument="viewRelatedDocument">
             <template #filter="{}">
                 <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Customer Name" placeholder="Customer Name" vid="customer_name" name="customer_name" v-model="filterForm.customer_name" size="sm" :disabled="false" :rules="''"/>
                 <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Mobile No." placeholder="Mobile No." vid="mobile" name="mobile" v-model="filterForm.mobile" size="sm" :disabled="false" :rules="''"/>
<!--                 <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Tier Name" v-model="filterForm.tier" :reduce="label => label.id" :reduceLabel="'label'" :options="tiers" :rules="''"></ThatsAutocomplete>-->
<!--                 <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Status" v-model="filterForm.status" :reduce="label => label.value" :reduceLabel="'label'" :options="customerStatus" :rules="''"></ThatsAutocomplete>-->
                 <ThatsMultiSelect :clearable="false"  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Tiers" v-model="filterForm.tier" :reduce="label => label.id" :reduceLabel="'label'" :options="tiers" :rules="''"></ThatsMultiSelect>
                 <ThatsMultiSelect :clearable="false"  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Status" v-model="filterForm.status" :reduce="label => label.value" :reduceLabel="'label'" :options="customerStatus" :rules="''"></ThatsMultiSelect>

             </template>
        </ThatsTable>
        <LoyaltyMemberForm ref="componentForm" @success="refreshTable"></LoyaltyMemberForm>
        <LoyaltyMemberCreateForm ref="componentCreateForm" @viewMember="viewMember"></LoyaltyMemberCreateForm>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters, mapMutations,mapActions } from 'vuex';
import ThatsTable from './Table'
import {mdbTabs, mdbRow, mdbCol, mdbBtn,mdbSelect, mdbInput,mdbBadge,mdbDropdown,mdbDropdownToggle,mdbDropdownMenu,mdbDropdownItem} from 'mdbvue'
import { MessageBox } from 'element-ui';
import DateRangePicker from 'vue2-daterange-picker'
import { ThatsDatePicker, ThatsMultiSelect, ThatsInput, ThatsAutocomplete} from '../../components/thats/Thats'
import ThatsMultiVueSelect from '../../components/thats/MultiVueSelect'
import { ValidationObserver,ValidationProvider } from "vee-validate";
import { Loading } from 'element-ui';
import LoyaltyMemberForm from './LoyaltyMemberForm.vue'
import LoyaltyMemberCreateForm from './LoyaltyMemberCreateForm.vue'

export default {
        components:{
        ThatsInput,
        ThatsTable,
        mdbTabs,
        mdbBadge,
        DateRangePicker, mdbRow, mdbCol,
        ThatsDatePicker,
        mdbBtn,
        mdbDropdown,mdbDropdownToggle,mdbDropdownMenu,mdbDropdownItem,
        ThatsMultiSelect,
        ValidationObserver,ValidationProvider,ThatsMultiVueSelect,LoyaltyMemberForm,LoyaltyMemberCreateForm,
        mdbSelect,
        mdbInput,

        ThatsAutocomplete,
    },

    provide(){
        return {

        }
    },
    data(){
        return {
            endpoint : 'loyalty-program/customers',
            viewTransactionLoading : 0,
            tableKey : 0,
            filterForm : {
                customer_name : null,
                mobile : null,
                tier : [],
                status : [],
            },
            area : [],
            tiers : [],
            category : [],
            collection : [],
            customerStatus:[
                { label : "Active", value : "active"},
                { label : "Inactive", value : "inactive"},
                { label : "For Issue Card", value : "for-issue-card"},
            ]
        }
    },
    created(){
        this.asyncGetData().then((res) => {
            this.tiers = res;
        })
    },

    mounted(){
        const self = this;

        // console.log("onmounted")
        this.$eventBus.$on('reloadTable',function(){
            self.tableKey++
            self.setFilters();
        })
    },
    methods: {
        ...mapActions('TireModule',[
            'asyncGetData'
        ]),
       ...mapActions('LoyaltyMemberModule',['getRecord','getTransactions']),
       ...mapMutations('LoyaltyMemberModule',['setFormStatusUpdate','setFormStatusCreate','setEmptyForm','setFilters']),

        rowClick(row){
            const self = this;

            const mergeFormData = {...JSON.parse(JSON.stringify(row))}

            const loading = Loading.service({
                fullscreen: true ,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            self.setFormStatusUpdate();
            this.getRecord(mergeFormData).then((res) => {
                loading.close();
                self.$refs.componentForm.openDialog();
            })
        },

        viewMember(row){
            this.$refs.componentCreateForm.closeDialog()
            this.rowClick(row)
        },


        viewRelatedDocument(obj){

            if(obj.reference == 'orderQty'){
                this.$refs.relatedDocumentDialogPurchaseOrder.triggerGetTransaction(obj.row)
            }
            if(obj.reference == 'incomingQty'){
                this.$refs.relatedDocumentDialogIncomingContainer.triggerGetTransaction(obj.row)
            }
            if(obj.reference == 'stock'){
                this.$refs.relatedDocumentDialogHistory.triggerGetTransaction(obj.row)
            }

        },
        openNewModal(){
            this.setFormStatusCreate();
            this.setEmptyForm();
           this.$refs.componentCreateForm.openDialog();
        },
        refreshTable(){
            // //alert(1)
            this.tableKey++
            this.$refs.table.refreshTable()

        },

        clearFilterForm(){
            this.filterForm = {
                customer_name : null,
                mobile : null,
                tier : [],
                status : [],
            }
        },


    },
    computed: {

        ...mapGetters('LoyaltyMemberModule',['getLoading', 'columns','initialFormObject']),

    },

    watch : {
        categoryComputed : function(value){
          console.log("watch category")
          console.log(value)
          this.category = value
      },
      areaComputed : function(value){
          console.log("watch area")
          console.log(value)
          this.area = value
      },
      collectionComputed : function(value){
          console.log("watch collectionComputed")
          console.log(value)
          this.collections = value
      }
    }
}


</script>
